import { createEffect } from "effector";
import { createInventoryItem } from "~/api/assets.api";
import { IInventoryItemAsset } from "~/types/IInventoryItemAsset";

export const createInventoryItemFx = createEffect(async ({ workspaceId }: { workspaceId: string }) => {
  const { body } = await createInventoryItem(workspaceId);

  return body as IInventoryItemAsset;
});
